export const LOADING_INDICATOR_STYLES = {
    'background-color': 'rgba(0, 0, 0, 0.4)',
    'z-index': '1000',
};

/**
 * PayPal SDK supported locales
 * https://developer.paypal.com/sdk/js/configuration/#link-locale
 */
export const PAYPAL_SDK_SUPPORTED_LOCALES = [
    'ar_BH',
    'ar_DZ',
    'ar_EG',
    'ar_JO',
    'ar_KW',
    'ar_MA',
    'ar_OM',
    'ar_QA',
    'ar_SA',
    'ar_TN',
    'ar_YE',
    'ar_AE',
    'bg_BG',
    'cs_CZ',
    'da_DK',
    'da_FO',
    'da_GL',
    'de_AT',
    'de_CH',
    'de_DE',
    'de_LU',
    'el_GR',
    'en_AD',
    'en_AE',
    'en_AG',
    'en_AI',
    'en_AL',
    'en_AM',
    'en_AN',
    'en_AO',
    'en_AT',
    'en_AU',
    'en_AW',
    'en_AZ',
    'en_BB',
    'en_BE',
    'en_BH',
    'en_BJ',
    'en_BM',
    'en_BN',
    'en_BS',
    'en_BT',
    'en_BW',
    'en_BY',
    'en_BZ',
    'en_C2',
    'en_CA',
    'en_CD',
    'en_CG',
    'en_CH',
    'en_CI',
    'en_CK',
    'en_CL',
    'en_CM',
    'en_CN',
    'en_CO',
    'en_CR',
    'en_CV',
    'en_CY',
    'en_CZ',
    'en_DE',
    'en_DJ',
    'en_DK',
    'en_DM',
    'en_DO',
    'en_DZ',
    'en_EC',
    'en_EE',
    'en_EG',
    'en_ER',
    'en_ES',
    'en_ET',
    'en_FI',
    'en_FJ',
    'en_FK',
    'en_FM',
    'en_FO',
    'en_FR',
    'en_GA',
    'en_GB',
    'en_GD',
    'en_GE',
    'en_GF',
    'en_GI',
    'en_GL',
    'en_GM',
    'en_GN',
    'en_GP',
    'en_GR',
    'en_GT',
    'en_GW',
    'en_GY',
    'en_HK',
    'en_HN',
    'en_HR',
    'en_HU',
    'en_ID',
    'en_IE',
    'en_IL',
    'en_IN',
    'en_IS',
    'en_IT',
    'en_JM',
    'en_JO',
    'en_JP',
    'en_KE',
    'en_KG',
    'en_KH',
    'en_KI',
    'en_KM',
    'en_KN',
    'en_KR',
    'en_KW',
    'en_KY',
    'en_KZ',
    'en_LA',
    'en_LC',
    'en_LI',
    'en_LK',
    'en_LS',
    'en_LT',
    'en_LU',
    'en_LV',
    'en_MA',
    'en_MC',
    'en_MD',
    'en_ME',
    'en_MG',
    'en_MH',
    'en_MK',
    'en_ML',
    'en_MN',
    'en_MQ',
    'en_MR',
    'en_MS',
    'en_MT',
    'en_MU',
    'en_MV',
    'en_MW',
    'en_MY',
    'en_MZ',
    'en_NA',
    'en_NC',
    'en_NE',
    'en_NF',
    'en_NG',
    'en_NI',
    'en_NL',
    'en_NO',
    'en_NP',
    'en_NR',
    'en_NU',
    'en_NZ',
    'en_OM',
    'en_PA',
    'en_PE',
    'en_PF',
    'en_PG',
    'en_PH',
    'en_PL',
    'en_PM',
    'en_PN',
    'en_PT',
    'en_PW',
    'en_PY',
    'en_QA',
    'en_RE',
    'en_RO',
    'en_RS',
    'en_RU',
    'en_RW',
    'en_SA',
    'en_SB',
    'en_SC',
    'en_SE',
    'en_SG',
    'en_SH',
    'en_SI',
    'en_SJ',
    'en_SK',
    'en_SL',
    'en_SM',
    'en_SN',
    'en_SO',
    'en_SR',
    'en_ST',
    'en_SV',
    'en_SZ',
    'en_TC',
    'en_TD',
    'en_TG',
    'en_TH',
    'en_TJ',
    'en_TM',
    'en_TN',
    'en_TO',
    'en_TR',
    'en_TT',
    'en_TV',
    'en_TW',
    'en_TZ',
    'en_UA',
    'en_UG',
    'en_US',
    'en_UY',
    'en_VA',
    'en_VC',
    'en_VE',
    'en_VG',
    'en_VN',
    'en_VU',
    'en_WF',
    'en_WS',
    'en_YE',
    'en_YT',
    'en_ZA',
    'en_ZM',
    'en_ZW',
    'es_AD',
    'es_AI',
    'es_AO',
    'es_AR',
    'es_AW',
    'es_BB',
    'es_BJ',
    'es_BM',
    'es_BO',
    'es_BS',
    'es_BZ',
    'es_CD',
    'es_CG',
    'es_CK',
    'es_CL',
    'es_CO',
    'es_CR',
    'es_CV',
    'es_DJ',
    'es_DM',
    'es_DO',
    'es_DZ',
    'es_EC',
    'es_EG',
    'es_ER',
    'es_ES',
    'es_ET',
    'es_FJ',
    'es_FK',
    'es_FO',
    'es_GA',
    'es_GD',
    'es_GE',
    'es_GI',
    'es_GL',
    'es_GM',
    'es_GN',
    'es_GT',
    'es_GW',
    'es_GY',
    'es_HN',
    'es_IE',
    'es_JM',
    'es_JO',
    'es_KE',
    'es_KG',
    'es_KI',
    'es_KM',
    'es_KN',
    'es_KW',
    'es_KY',
    'es_KZ',
    'es_LC',
    'es_LI',
    'es_LS',
    'es_LU',
    'es_MA',
    'es_MG',
    'es_MH',
    'es_ML',
    'es_MR',
    'es_MS',
    'es_MU',
    'es_MW',
    'es_MX',
    'es_MZ',
    'es_NA',
    'es_NC',
    'es_NE',
    'es_NF',
    'es_NI',
    'es_NR',
    'es_NU',
    'es_NZ',
    'es_OM',
    'es_PA',
    'es_PE',
    'es_PF',
    'es_PG',
    'es_PM',
    'es_PN',
    'es_PW',
    'es_PY',
    'es_QA',
    'es_RS',
    'es_RW',
    'es_SA',
    'es_SB',
    'es_SC',
    'es_SH',
    'es_SJ',
    'es_SL',
    'es_SM',
    'es_SN',
    'es_SO',
    'es_SR',
    'es_ST',
    'es_SV',
    'es_SZ',
    'es_TC',
    'es_TD',
    'es_TG',
    'es_TJ',
    'es_TM',
    'es_TN',
    'es_TT',
    'es_TV',
    'es_UA',
    'es_UG',
    'es_US',
    'es_UY',
    'es_VA',
    'es_VC',
    'es_VE',
    'es_VG',
    'es_VU',
    'es_WF',
    'es_YE',
    'es_ZM',
    'et_EE',
    'fi_FI',
    'fr_AD',
    'fr_AE',
    'fr_AI',
    'fr_AM',
    'fr_AO',
    'fr_AW',
    'fr_AZ',
    'fr_BB',
    'fr_BE',
    'fr_BF',
    'fr_BI',
    'fr_BJ',
    'fr_BM',
    'fr_BS',
    'fr_BZ',
    'fr_CA',
    'fr_CD',
    'fr_CG',
    'fr_CH',
    'fr_CI',
    'fr_CK',
    'fr_CM',
    'fr_CV',
    'fr_DJ',
    'fr_DM',
    'fr_DO',
    'fr_DZ',
    'fr_EC',
    'fr_ER',
    'fr_ET',
    'fr_FJ',
    'fr_FK',
    'fr_FO',
    'fr_FR',
    'fr_GA',
    'fr_GD',
    'fr_GE',
    'fr_GF',
    'fr_GI',
    'fr_GL',
    'fr_GM',
    'fr_GN',
    'fr_GP',
    'fr_GT',
    'fr_GW',
    'fr_GY',
    'fr_HN',
    'fr_IE',
    'fr_JM',
    'fr_JO',
    'fr_KE',
    'fr_KG',
    'fr_KI',
    'fr_KM',
    'fr_KN',
    'fr_KW',
    'fr_KY',
    'fr_KZ',
    'fr_LC',
    'fr_LI',
    'fr_LS',
    'fr_LU',
    'fr_MA',
    'fr_MC',
    'fr_MG',
    'fr_MH',
    'fr_ML',
    'fr_MQ',
    'fr_MR',
    'fr_MS',
    'fr_MU',
    'fr_MW',
    'fr_MZ',
    'fr_NA',
    'fr_NC',
    'fr_NE',
    'fr_NF',
    'fr_NI',
    'fr_NR',
    'fr_NU',
    'fr_NZ',
    'fr_OM',
    'fr_PA',
    'fr_PE',
    'fr_PF',
    'fr_PG',
    'fr_PM',
    'fr_PN',
    'fr_PW',
    'fr_QA',
    'fr_RE',
    'fr_RS',
    'fr_RW',
    'fr_SA',
    'fr_SB',
    'fr_SC',
    'fr_SH',
    'fr_SJ',
    'fr_SL',
    'fr_SM',
    'fr_SN',
    'fr_SO',
    'fr_SR',
    'fr_ST',
    'fr_SV',
    'fr_SZ',
    'fr_TC',
    'fr_TD',
    'fr_TG',
    'fr_TJ',
    'fr_TM',
    'fr_TN',
    'fr_TT',
    'fr_TV',
    'fr_UA',
    'fr_UG',
    'fr_US',
    'fr_UY',
    'fr_VA',
    'fr_VC',
    'fr_VE',
    'fr_VG',
    'fr_VU',
    'fr_WF',
    'fr_YE',
    'fr_YT',
    'fr_ZA',
    'fr_ZM',
    'he_IL',
    'hu_HU',
    'id_ID',
    'it_IT',
    'ja_JP',
    'ko_KR',
    'lv_LV',
    'lt_LT',
    'ms_BN',
    'ms_MY',
    'nl_BE',
    'nl_NL',
    'pl_PL',
    'pt_BR',
    'pt_PT',
    'ro_RO',
    'ru_EE',
    'ru_LT',
    'ru_LV',
    'ru_RU',
    'ru_UA',
    'si_LK',
    'sk_SK',
    'sl_SI',
    'sq_AL',
    'sv_SE',
    'tl_PH',
    'th_TH',
    'tr_TR',
    'vi_VN',
    'zh_C2',
    'zh_CN',
    'zh_HK',
    'zh_TW',
    'zh_AD',
    'zh_AE',
    'zh_AI',
    'zh_AO',
    'zh_AW',
    'zh_BB',
    'zh_BH',
    'zh_BJ',
    'zh_BM',
    'zh_BS',
    'zh_BZ',
    'zh_CD',
    'zh_CG',
    'zh_CK',
    'zh_CL',
    'zh_CO',
    'zh_CV',
    'zh_DJ',
    'zh_DM',
    'zh_DO',
    'zh_DZ',
    'zh_EC',
    'zh_EG',
    'zh_ER',
    'zh_ET',
    'zh_FJ',
    'zh_FK',
    'zh_FO',
    'zh_GA',
    'zh_GD',
    'zh_GE',
    'zh_GI',
    'zh_GL',
    'zh_GM',
    'zh_GN',
    'zh_GT',
    'zh_GW',
    'zh_GY',
    'zh_HN',
    'zh_IE',
    'zh_JM',
    'zh_JO',
    'zh_KE',
    'zh_KG',
    'zh_KI',
    'zh_KM',
    'zh_KN',
    'zh_KW',
    'zh_KY',
    'zh_KZ',
    'zh_LC',
    'zh_LI',
    'zh_LS',
    'zh_LT',
    'zh_LU',
    'zh_MA',
    'zh_MG',
    'zh_MH',
    'zh_ML',
    'zh_MR',
    'zh_MS',
    'zh_MU',
    'zh_MW',
    'zh_MZ',
    'zh_NA',
    'zh_NC',
    'zh_NE',
    'zh_NF',
    'zh_NI',
    'zh_NR',
    'zh_NU',
    'zh_NZ',
    'zh_OM',
    'zh_PA',
    'zh_PE',
    'zh_PF',
    'zh_PG',
    'zh_PM',
    'zh_PN',
    'zh_PW',
    'zh_QA',
    'zh_RS',
    'zh_RW',
    'zh_SA',
    'zh_SB',
    'zh_SC',
    'zh_SH',
    'zh_SJ',
    'zh_SL',
    'zh_SM',
    'zh_SN',
    'zh_SO',
    'zh_SR',
    'zh_ST',
    'zh_SV',
    'zh_SZ',
    'zh_TC',
    'zh_TD',
    'zh_TG',
    'zh_TJ',
    'zh_TM',
    'zh_TN',
    'zh_TT',
    'zh_TV',
    'zh_UA',
    'zh_UG',
    'zh_US',
    'zh_UY',
    'zh_VA',
    'zh_VC',
    'zh_VE',
    'zh_VG',
    'zh_VU',
    'zh_WF',
    'zh_YE',
    'zh_ZA',
    'zh_ZM',
];
